const t = new Intl.NumberFormat("en-AU", { currency: "AUD", style: "currency" }), c = (e) => t.format(e), n = (e, r) => `${Math.round((e - r) / e * 100)}%`;
export {
  n as calculateSavingsPercentage,
  c as formatPrice
};
